import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding: 24px;
`;
